module.exports = __webpack_public_path__ + "bin/d9e29e809c9716ab6c464861d840478b.svg";